export default function shouldHaveTwitch(influencer) {
  return (
    influencer && influencer.twitch_streamer && influencer.twitch_streamer.login
  );
}
